export default __webpack_public_path__ + "static/media/alastorgreet.fc0ad912.wav";